<script>
  // What a page shows a signed-out viewer in place of what only a Signed-in
  // Viewer may see (the user page, the want page): a heading, one line of
  // why, and Sign in with Discord, which comes back to this page.
  import { initiateDiscordOAuth } from '../../lib/stores/auth.svelte.js';

  /** @type {{ title: string, text: string }} */
  let { title, text } = $props();
</script>

<div class="sign-in-prompt">
  <h2>{title}</h2>
  <p>{text}</p>
  <button class="btn-discord" onclick={() => initiateDiscordOAuth(window.location.pathname)}>
    Sign in with Discord
  </button>
</div>

<style>
  .sign-in-prompt {
    padding: 64px 0;
    text-align: center;
    color: var(--color-text-tertiary);
  }
  .sign-in-prompt h2 {
    font-family: var(--font-serif);
    color: var(--color-text);
    margin: 0 0 8px;
  }
  .btn-discord {
    margin-top: var(--space-sm);
    padding: 12px 24px;
    background: #5865f2;
    color: white;
    border: none;
    border-radius: 10px;
    font-family: inherit;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
  }
  .btn-discord:hover {
    background: #4752c4;
  }
</style>
